import { render, staticRenderFns } from "./ObservationThreePage.vue?vue&type=template&id=5e994d9e&scoped=true&"
import script from "./ObservationThreePage.vue?vue&type=script&lang=js&"
export * from "./ObservationThreePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e994d9e",
  null
  
)

export default component.exports